fragment SalesDocumentTemplateFragment on SalesDocument {
    id
    creatorUser {
        id
        name
    }
    createdTime
    modifiedTime
    headerLeftColumn
    headerRightColumn
    body
    footer
    isSkuShown
    isTermShown
    isDiscountShown
    logo
    ... on Invoice {
        purchaseOrderNumber
        jobNumber
        customerNumber
        referenceNumber
        paymentAndTerms
    }
}
